import { render, staticRenderFns } from "./b-detail-step.vue?vue&type=template&id=6cc36230&scoped=true"
import script from "./b-detail-step.vue?vue&type=script&lang=js"
export * from "./b-detail-step.vue?vue&type=script&lang=js"
import style0 from "./b-detail-step.vue?vue&type=style&index=0&id=6cc36230&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc36230",
  null
  
)

export default component.exports